import { ALL_JOBS_REQUEST, ALL_JOBS_SUCCESS, ALL_JOBS_FAIL } from "../constants/AuthConstant";

const initialState = {
  loading: false,
  action: "All Action",
  result: null,
  msg: "",
  error: "",
};

const AllNewJobsListReducer = (state = initialState, action) => {
  switch (action.type) {
    case ALL_JOBS_REQUEST:
      return {
        ...state,
        loading: action.payload,
      };
    case ALL_JOBS_SUCCESS:
      return {
        ...state,
        result: action.result.data,
        loading: action.payload,
        msg: action.msg,
      };
    case ALL_JOBS_FAIL:
      return {
        ...state,
        error: action.error,
        loading: action.payload,
        msg: action.msg,
      };

    default:
      return state;
  }
};

export default AllNewJobsListReducer;
